<div class="no-entries-content">
  <wchfs-icon svgIcon="pso:info_xl" color="secondary" size="60"></wchfs-icon>
  <div class="no-entries-title">{{ title | translate }}</div>
  <div class="no-entries-desc">{{ description | translate }}</div>
</div>
